import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div>
            <h2 className='mt-5'>404 - Page Not Found</h2>
            <p>The page you're looking for doesn't exist.</p>
            <p>
                <Link to='/'>
                    <span className='text-secondary-900'>Go back to the homepage</span>
                </Link>
            </p>
        </div>
    );
};

export default NotFound;
